import { DiscoverAIEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const createConnection = async (data: any): Promise<any> =>
  APIManager.sendPost(DiscoverAIEnds.CREATE, data, true, {}, {}, axios);

const getConnections = async (connectionType: string): Promise<any> =>
  APIManager.sendGet(
    DiscoverAIEnds.GET_ALL(connectionType),
    true,
    {},
    {},
    axios
  );

const deleteConnection = async (id: string): Promise<any> =>
  APIManager.sendDelete(DiscoverAIEnds.DELETE(id), true, {}, {}, axios);

const getGitRepos = async (id: string): Promise<any> =>
  APIManager.sendGet(DiscoverAIEnds.GIT_REPOS(id), true, {}, {}, axios);

const getHuggingModels = async (
  search: string,
  connectionId: string
): Promise<any> =>
  APIManager.sendGet(
    DiscoverAIEnds.HUGGING_MODELS(search, connectionId),
    true,
    {},
    {},
    axios
  );

const importHuggingFace = async (data: any): Promise<any> =>
  APIManager.sendPost(
    DiscoverAIEnds.IMPORT_HUGGING_FACE,
    data,
    true,
    {},
    {},
    axios
  );

const getImportHistory = async (id: string): Promise<any> =>
  APIManager.sendGet(DiscoverAIEnds.IMPORT_History(id), true, {}, {}, axios);

export const DiscoverAIService = {
  createConnection,
  deleteConnection,
  getConnections,
  getGitRepos,
  getHuggingModels,
  importHuggingFace,
  getImportHistory,
};
